import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { MODAL_CLOSE_BUTTON_CLASS } from "@config/theme/modal";

interface ModalCloseButtonProps {
	onClose: () => void;
	className?: string;
}

const ModalCloseButton = ({ onClose, className = "" }: ModalCloseButtonProps) => (
	<button
		type="button"
		onClick={onClose}
		aria-label="Close"
		className={`${MODAL_CLOSE_BUTTON_CLASS} ${className}`.trim()}
	>
		<CloseOutlined sx={{ fontSize: 20, fontWeight: 600 }} />
	</button>
);

export default ModalCloseButton;
